/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Warning_Lines_LabelInputs */



/**
* | output |
* | --- |
* | "Lines" |
*
* @param {Event_Warning_Lines_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_warning_lines_label = /** @type {((inputs?: Event_Warning_Lines_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Warning_Lines_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lignes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Linien")
	if (locale === "it") return /** @type {LocalizedString} */ ("Linee")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Линии")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pauta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("线条")
	if (locale === "ja") return /** @type {LocalizedString} */ ("線")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पंक्तियां")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Linhas")
	return /** @type {LocalizedString} */ ("Lines")
});